import React from "react";
// import { PieChart } from "react-minimal-pie-chart";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import styles from "../../config/styles";

const DashboardChart = ({ className, title, amount, icon }) => {
  let value;
  let remainingValue;
  if (amount) {
    value = parseInt(amount.split("%")[0], 10);
    remainingValue = 100 - value;
  }

  return (
    <div className={`chart ${className}`}>
         <FontAwesomeIcon icon={['fas', icon]} />
         <div className="pie-chart-amount">
          <h1>{amount}</h1>
          <p className="chart-header">
            {title}
          </p>
        </div>
    </div>
  );
};

DashboardChart.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  amount: PropTypes.string,
};

DashboardChart.defaultProps = {
  className: "",
  title: "",
  amount: "0%",
};

export default DashboardChart;